@if (feed !== null || feed !== undefined) {
  <div
    class="feedback"
    [className]="feed?.className"
    [ngStyle]="getFEEDStyles()"
    style="height: 100%"
  >
    <form (ngSubmit)="submitFeedback(f)" #f="ngForm">
      <div class="feedback-trim">
        @if (feed?.title) {
          <div class="feedback-desc">
            <h3>{{ feed?.title }}</h3>
          </div>
        }
        <div class="feedback-inputs">
          @if (feed?.name) {
            <div class="form-input">
              <input
                matInput
                id="feedback-name"
                type="text"
                placeholder="Enter Your Name"
                title="Enter Your Name"
                name="name"
                ngModel
                [ngStyle]="{ 'background-color': $safeNavigationMigration(feed?.inputBack) }"
              />
              <label for="feedback-name">
                <span [ngStyle]="{ color: $safeNavigationMigration(feed?.labelColor) }"
                  >Name (required)</span
                >
              </label>
            </div>
          }
          @if (feed?.email) {
            <div class="form-input">
              <input
                id="feedback-email"
                type="email"
                placeholder="Enter Your Email"
                title="Enter Your Email"
                name="email"
                ngModel
                [ngStyle]="{ 'background-color': $safeNavigationMigration(feed?.inputBack) }"
              />
              <label for="feedback-email">
                <span [ngStyle]="{ color: $safeNavigationMigration(feed?.labelColor) }"
                  >Email (required)</span
                >
              </label>
            </div>
          }
          @if (feed?.phone) {
            <div class="form-input">
              <input
                id="feedback-phone"
                type="tel"
                placeholder="Enter Your Phone"
                title="Enter Your Phone"
                name="phone"
                ngModel
                [ngStyle]="{ 'background-color': $safeNavigationMigration(feed?.inputBack) }"
              />
              <label for="feedback-phone">
                <span [ngStyle]="{ color: $safeNavigationMigration(feed?.labelColor) }">Phone</span>
              </label>
            </div>
          }
          @if (feed?.emailCheckbox) {
            <div class="form-checkbox">
              <input
                type="checkbox"
                id="reply-checkbox"
                (click)="toggleEmail()"
                name="replyEmail"
                ngModel
                title="if reply Email is required"
                [ngStyle]="{ 'background-color': $safeNavigationMigration(feed?.inputBack) }"
              />
              <label
                for="reply-checkbox"
                [ngStyle]="{ color: $safeNavigationMigration(feed?.labelColor) }"
              >
                Include Reply Email</label
              >
            </div>
          }
        </div>
        <div class="feedback-story">
          <div class="feedback-select">
            <select
              name="option"
              [ngModel]="feedbackType"
              required="true"
              title="Choose a Feedback Option"
              [ngStyle]="{
                color: $safeNavigationMigration(feed?.labelColor),
                'background-color': $safeNavigationMigration(feed?.inputBack)
              }"
            >
              <option [ngValue]="null" value="default" selected>
                -- Select an Option (required)--
              </option>
              <option value="suggestion">Suggestion</option>
              <option value="question">Questions</option>
              <option value="compliment">Compliment</option>
              <option value="complaint">Problems or Complaint</option>
            </select>
          </div>
          <div class="feedback-details">
            <textarea
              rows="3"
              [placeholder]="feed?.placeholder ? feed.placeholder : 'write us a message'"
              ngModel
              name="description"
              [attr.title]="feed?.placeholder ? feed.placeholder : 'write us a message'"
              [ngStyle]="{
                color: $safeNavigationMigration(feed?.labelColor),
                'background-color': $safeNavigationMigration(feed?.inputBack)
              }"
            >
            </textarea>
          </div>
          <div class="feedback-buttons">
            @if (feed?.resetButton) {
              <input
                type="button"
                value="reset"
                title="Reset"
                class="btn btn-link"
                (click)="resetForm(f)"
                [disabled]="!f.touched"
              />
            }
            <input
              type="submit"
              value="send"
              title="Send"
              [value]="feed?.sendButton ? $safeNavigationMigration(feed?.sendButton) : 'Send'"
              [ngClass]="
                feed?.btnClass ? $safeNavigationMigration(feed?.btnClass) : 'btn btn-primary'
              "
            />
          </div>
        </div>
      </div>
    </form>
  </div>
}
